import React from "react";
import {Card, Flex} from "antd";
// import {useNavigate} from "react-router-dom";
import {DeleteOutlined} from "@ant-design/icons";
// import {threadId} from "worker_threads";
// import {types} from "sass";
// import List = types.List;
import '../../styles/component/chat.scss';

export interface IChatPayload {
    ownerUserId?: string
    "chatName": string;
    "chatType": string;
    // "chatStatus" : string;
    "participantUserIds" : string[];
}

export interface IChat {
    "id": string;
    "chatName": string;
    "chatType": string;
    // "chatStatus" : string;
    "participantUserIds" : string[];

    "auditInfo": {
        "createdOn": string;
        "createdBy": string;
        "updatedOn": string;
        "updatedBy": string;
    }
}

const ChatList = (props: any) => {
    // const navigate = useNavigate();
    return (<>
        {/* 1. call threads api and identify how many threads is available */}
        {/* 2. render list */}
        <section style={{textAlign: "center", marginTop: 10}}>
            {props.allChats.map((chat: IChat) => <Card
                    key={chat.id}
                    onClick={() => {
                        //todo pass function from parent then implement future changes in one place
                        props.onClickAnotherChat(chat);
                        props.getAllMessageSelectedChat()
                        // navigate(`/chat/${chat.id}`)
                    }
                    }
                    // title={chat.threadName}
                className={"chatNameSection"}
                    style={{marginTop: 5, backgroundColor : props.selectedChat.id===chat.id?"#DDE3FF":""}}
                >

                    <Flex justify={"space-between"}>
                        <div>
                            {chat.chatName}
                            {/*<Divider  style={{margin: 0, width: "fit-content"}}/>*/}
                            {/*{chat.auditInfo.createdOn}*/}
                        </div>
                        <div>
                            <DeleteOutlined onClick={()=>props.deleteChat(chat.id)} className={"chatDeleteButton"} />
                        </div>
                    </Flex>
                </Card>
            )}
        </section>
    </>)
}
export default ChatList